

import symbolObservable from 'symbol-observable';

import { configureStore } from '@reduxjs/toolkit';
import { combineReducers } from '@reduxjs/toolkit';
import {  compose } from 'redux';
import { websocketSlice } from '../websocketSlice';
import { userSessionSlice } from '../userSessionSlice';
import { chartSlice } from '../chartSlice';
import { tokenDataSlice } from '../TokenDataSlice';
import { SessionSlice } from '../SessionSlice';
import { pricesSlice } from '../pricesSlice/pricesSlice';
import { searchTokenSlice } from '../searchTokenSlice';
import { RaydiumBotSlice } from '../RaydiumBotSlice/RaydiumBotSlice';
import { icoSlice } from '../icoSlice';

if (!Symbol.observable) {
    Symbol.observable = symbolObservable;
  }
 


  const rootReducer = combineReducers({
    [websocketSlice.name]:websocketSlice.reducer,
    [userSessionSlice.name]:userSessionSlice.reducer,
    [chartSlice.name]:chartSlice.reducer,
    [tokenDataSlice.name]:tokenDataSlice.reducer,
    [SessionSlice.name]:SessionSlice.reducer,
    [pricesSlice.name]:pricesSlice.reducer,
    [searchTokenSlice.name]:searchTokenSlice.reducer,
    [RaydiumBotSlice.name]:RaydiumBotSlice.reducer,
    })

const composeEnhancers =
  process.env.NODE_ENV !== 'production'
    ? window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose
    : compose;

export const store = configureStore({
  reducer: rootReducer,
  devTools: process.env.NODE_ENV !== 'production',
  compose: composeEnhancers,
});




